import { JupiterTheme } from '@jupiterone/jupiter-web-toolkit';
import { Button, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';
import { MANAGE_JUPITERONE_PRICING_PLAN } from '@jupiterone/jupiter-web-toolkit/src//constants';

const useEntitlementsUpgradeButtonStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    learnMoreButton: {
      padding: theme.spacing(0, 1),
      fontSize: 12,
    },
  })
);

export const EntitlementsUpgradeButton = () => {
  const classes = useEntitlementsUpgradeButtonStyles();

  return (
    <Button
      onClick={() =>
        (window.location.pathname = MANAGE_JUPITERONE_PRICING_PLAN)
      }
      variant="contained"
      size="small"
      color="primary"
      className={classes.learnMoreButton}
    >
      Learn more{' '}
    </Button>
  );
};

const useEntitlementsPromptStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    titleContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    prompt: { marginBottom: theme.spacing() },
  })
);

interface EntitlementsPromptProps {
  prompt: string;
}

export const EntitlementsPrompt = ({ prompt }: EntitlementsPromptProps) => {
  const classes = useEntitlementsPromptStyles();

  return (
    <div className={classes.titleContainer}>
      <Typography variant="caption" className={classes.prompt}>
        {prompt}
      </Typography>
      <EntitlementsUpgradeButton />
    </div>
  );
};
